import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stockgroup-report',
  templateUrl: './stockgroup-report.component.html',
  styleUrls: ['./stockgroup-report.component.css']
})
export class StockgroupReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
